import { render, staticRenderFns } from "./HotelAvailabilityWidget.vue?vue&type=template&id=ed15a6de&"
import script from "./HotelAvailabilityWidget.vue?vue&type=script&lang=js&"
export * from "./HotelAvailabilityWidget.vue?vue&type=script&lang=js&"
import style0 from "./HotelAvailabilityWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports